import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { changePassword } from '@fmr-pr179005/reset-cred/lib/resetpassword.bundle.min';
import { NextGenUtilService } from 'src/app/common/util/nextgen-util.service';
import {
  CC_APP_ID,
  PUBLIC_LOGIN_PATH,
  SYSTEM_ERROR_PAGE_VALUE,
} from 'src/app/constants/NextGenConstants';
import { CancelParameter } from 'src/app/public/models/CancelParameter';

@Component({
  selector: 'app-reset-password',
  imports: [],
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
  private readonly nextGenUtilService = inject(NextGenUtilService);

  ngOnInit(): void {
    globalThis.onSuccessfullResetPassword = () => {
      try {
        this.location.assign(PUBLIC_LOGIN_PATH);
      } catch (error) {
        console.error('onSuccessfullResetPassword: ', error);
      }
    };

    globalThis.onDomCancel = (cancelParameter: CancelParameter) => {
      try {
        if (cancelParameter.page === SYSTEM_ERROR_PAGE_VALUE) {
          this.location.assign(PUBLIC_LOGIN_PATH);
        } else {
          window.history.back();
        }
      } catch (error) {
        console.error('onDomCancel: ', error);
      }
    };

    changePassword(
      {
        ecaapEndpoint: this.nextGenUtilService.getEcaapUrl(
          this.location.hostname,
        ),
        appId: CC_APP_ID,
        appName: CC_APP_ID,
      },
      { type: '', statusCode: 0 },
    );
  }

  // Returns the window.location object. Defined for easier mocks.
  private get location(): Location {
    return window.location;
  }

  ngOnDestroy(): void {
    // Destroy global callbacks
    delete globalThis.onDomCancel;
    delete globalThis.onSuccessfullResetPassword;
  }
}
